/**
 * Generate sample CSV data for templates
 */

export const generateCustomerDataCSV = () => {
  const headers = ['customer_id', 'full_name', 'date_of_birth', 'phone', 'email', 'address', 'account_balance', 'credit_score', 'risk_level', 'status'];
  
  const data = [
    ['KH001', 'Nguyễn Văn A', '15/05/1985', '0901234567', 'nguyenvana@gmail.com', '123 Lê Lợi, Q1, TP.HCM', '150000000', '720', 'Low', 'Active'],
    ['KH002', 'Trần Thị B', '20/08/1990', '0902345678', 'tranthib@gmail.com', '456 Nguyễn Huệ, Q1, TP.HCM', '85000000', '650', 'Medium', 'Active'],
    ['KH003', 'Lê Văn C', '10/03/1988', '0903456789', 'levanc@gmail.com', '789 Điện Biên Phủ, Q3, TP.HCM', '250000000', '780', 'Low', 'Active'],
    ['KH004', 'Phạm Thị D', '25/11/1992', '0904567890', 'phamthid@gmail.com', '321 Hai Bà Trưng, Q3, TP.HCM', '45000000', '580', 'High', 'Active'],
    ['KH005', 'Hoàng Văn E', '05/07/1987', '0905678901', 'hoangvane@gmail.com', '654 Võ Văn Tần, Q3, TP.HCM', '120000000', '690', 'Medium', 'Active'],
    ['KH006', 'Vũ Thị F', '12/02/1995', '0906789012', 'vuthif@gmail.com', '987 Nguyễn Đình Chiểu, Q3, TP.HCM', '200000000', '750', 'Low', 'Active'],
    ['KH007', 'Đỗ Văn G', '30/09/1983', '0907890123', 'dovang@gmail.com', '111 Nam Kỳ Khởi Nghĩa, Q1, TP.HCM', '35000000', '520', 'High', 'Warning'],
    ['KH008', 'Bùi Thị H', '18/04/1991', '0908901234', 'buithih@gmail.com', '222 Trần Hưng Đạo, Q1, TP.HCM', '180000000', '710', 'Low', 'Active'],
    ['KH009', 'Ngô Văn I', '22/06/1989', '0909012345', 'ngovani@gmail.com', '333 Lý Thường Kiệt, Q10, TP.HCM', '95000000', '640', 'Medium', 'Active'],
    ['KH010', 'Trương Thị K', '08/12/1994', '0900123456', 'truongthik@gmail.com', '444 Cách Mạng Tháng 8, Q3, TP.HCM', '25000000', '550', 'High', 'Alert']
  ];
  
  return [headers, ...data].map(row => row.join(',')).join('\n');
};

export const generateLoanDataCSV = () => {
  const headers = ['loan_id', 'customer_id', 'loan_type', 'loan_amount', 'interest_rate', 'loan_term_months', 'start_date', 'due_date', 'outstanding_balance', 'overdue_days', 'status'];
  
  const data = [
    ['LN001', 'KH001', 'Mortgage', '500000000', '8.5', '240', '01/01/2024', '01/01/2044', '485000000', '0', 'Current'],
    ['LN002', 'KH002', 'Personal', '80000000', '12.0', '36', '15/03/2024', '15/03/2027', '65000000', '5', 'Current'],
    ['LN003', 'KH003', 'Business', '1200000000', '10.5', '120', '20/02/2024', '20/02/2034', '1150000000', '0', 'Current'],
    ['LN004', 'KH004', 'Personal', '50000000', '13.5', '24', '10/04/2024', '10/04/2026', '28000000', '45', 'Overdue'],
    ['LN005', 'KH005', 'Auto', '350000000', '9.0', '60', '05/05/2024', '05/05/2029', '310000000', '0', 'Current'],
    ['LN006', 'KH006', 'Mortgage', '800000000', '8.0', '300', '12/01/2024', '12/01/2049', '790000000', '0', 'Current'],
    ['LN007', 'KH007', 'Personal', '60000000', '14.0', '18', '25/06/2024', '25/12/2025', '42000000', '92', 'Overdue'],
    ['LN008', 'KH008', 'Business', '600000000', '11.0', '84', '18/02/2024', '18/02/2031', '575000000', '0', 'Current'],
    ['LN009', 'KH009', 'Personal', '90000000', '12.5', '36', '22/03/2024', '22/03/2027', '75000000', '12', 'Warning'],
    ['LN010', 'KH010', 'Auto', '280000000', '9.5', '48', '08/04/2024', '08/04/2028', '245000000', '0', 'Current']
  ];
  
  return [headers, ...data].map(row => row.join(',')).join('\n');
};

export const generateTransactionDataCSV = () => {
  const headers = ['transaction_id', 'customer_id', 'transaction_date', 'transaction_type', 'amount', 'description', 'balance_after', 'channel', 'status'];
  
  const data = [
    ['TXN001', 'KH001', '01/06/2026', 'Deposit', '50000000', 'Salary', '150000000', 'Internet Banking', 'Success'],
    ['TXN002', 'KH001', '05/06/2026', 'Withdrawal', '5000000', 'ATM Withdrawal', '145000000', 'ATM', 'Success'],
    ['TXN003', 'KH002', '02/06/2026', 'Transfer', '10000000', 'Payment to supplier', '75000000', 'Mobile Banking', 'Success'],
    ['TXN004', 'KH002', '10/06/2026', 'Deposit', '20000000', 'Customer payment', '95000000', 'Branch', 'Success'],
    ['TXN005', 'KH003', '03/06/2026', 'Payment', '15000000', 'Loan repayment', '235000000', 'Internet Banking', 'Success'],
    ['TXN006', 'KH004', '04/06/2026', 'Withdrawal', '8000000', 'Cash withdrawal', '37000000', 'Branch', 'Success'],
    ['TXN007', 'KH004', '12/06/2026', 'Transfer', '12000000', 'Bill payment', '25000000', 'Mobile Banking', 'Failed'],
    ['TXN008', 'KH005', '06/06/2026', 'Deposit', '30000000', 'Investment return', '150000000', 'Internet Banking', 'Success'],
    ['TXN009', 'KH006', '07/06/2026', 'Payment', '20000000', 'Loan installment', '180000000', 'Auto Debit', 'Success'],
    ['TXN010', 'KH007', '08/06/2026', 'Withdrawal', '15000000', 'Emergency withdrawal', '20000000', 'ATM', 'Success'],
    ['TXN011', 'KH008', '09/06/2026', 'Transfer', '25000000', 'Vendor payment', '155000000', 'Internet Banking', 'Success'],
    ['TXN012', 'KH009', '11/06/2026', 'Deposit', '18000000', 'Client payment', '113000000', 'Branch', 'Success'],
    ['TXN013', 'KH010', '13/06/2026', 'Payment', '5000000', 'Utility bill', '20000000', 'Mobile Banking', 'Success']
  ];
  
  return [headers, ...data].map(row => row.join(',')).join('\n');
};

export const generateCreditScoreCSV = () => {
  const headers = ['customer_id', 'cic_score', 'rating', 'total_loans', 'total_debt', 'overdue_count', 'last_updated', 'risk_category'];
  
  const data = [
    ['KH001', '720', 'Good', '2', '485000000', '0', '28/05/2026', 'Low Risk'],
    ['KH002', '650', 'Fair', '1', '65000000', '1', '28/05/2026', 'Medium Risk'],
    ['KH003', '780', 'Excellent', '1', '1150000000', '0', '28/05/2026', 'Low Risk'],
    ['KH004', '580', 'Poor', '2', '28000000', '3', '28/05/2026', 'High Risk'],
    ['KH005', '690', 'Good', '1', '310000000', '0', '28/05/2026', 'Low Risk'],
    ['KH006', '750', 'Very Good', '1', '790000000', '0', '28/05/2026', 'Low Risk'],
    ['KH007', '520', 'Poor', '1', '42000000', '5', '28/05/2026', 'High Risk'],
    ['KH008', '710', 'Good', '1', '575000000', '0', '28/05/2026', 'Low Risk'],
    ['KH009', '640', 'Fair', '1', '75000000', '1', '28/05/2026', 'Medium Risk'],
    ['KH010', '550', 'Poor', '1', '245000000', '2', '28/05/2026', 'High Risk']
  ];
  
  return [headers, ...data].map(row => row.join(',')).join('\n');
};

export const generateComplianceReportCSV = () => {
  const headers = ['report_id', 'customer_id', 'report_date', 'report_type', 'compliance_status', 'risk_score', 'findings_count', 'reviewer', 'remarks'];
  
  const data = [
    ['CR001', 'KH001', '15/06/2026', 'KYC Review', 'Compliant', '15', '0', 'Nguyễn Thị X', 'Đã hoàn thành KYC đầy đủ'],
    ['CR002', 'KH002', '16/06/2026', 'AML Check', 'Compliant', '22', '1', 'Trần Văn Y', 'Phát hiện 1 giao dịch bất thường nhỏ'],
    ['CR003', 'KH003', '17/06/2026', 'Credit Review', 'Compliant', '10', '0', 'Lê Thị Z', 'Hồ sơ tín dụng tốt'],
    ['CR004', 'KH004', '18/06/2026', 'KYC Review', 'Non-Compliant', '85', '3', 'Phạm Văn W', 'Thiếu giấy tờ cập nhật'],
    ['CR005', 'KH005', '19/06/2026', 'Transaction Monitor', 'Compliant', '18', '0', 'Hoàng Thị V', 'Giao dịch bình thường'],
    ['CR006', 'KH006', '20/06/2026', 'AML Check', 'Compliant', '12', '0', 'Vũ Văn U', 'Không có dấu hiệu rủi ro'],
    ['CR007', 'KH007', '21/06/2026', 'Credit Review', 'Review Required', '72', '4', 'Đỗ Thị T', 'Cần xem xét thêm về nợ quá hạn'],
    ['CR008', 'KH008', '22/06/2026', 'KYC Review', 'Compliant', '14', '0', 'Bùi Văn S', 'KYC đầy đủ và cập nhật'],
    ['CR009', 'KH009', '23/06/2026', 'Transaction Monitor', 'Compliant', '25', '1', 'Ngô Thị R', 'Một giao dịch cần giải trình'],
    ['CR010', 'KH010', '24/06/2026', 'AML Check', 'Review Required', '68', '2', 'Trương Văn Q', 'Cần kiểm tra nguồn gốc tiền']
  ];
  
  return [headers, ...data].map(row => row.join(',')).join('\n');
};

// Download CSV helper
export const downloadCSV = (filename, csvContent) => {
  const blob = new Blob(['\ufeff' + csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  if (link.download !== undefined) {
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
};

// Get sample data by template name
export const getSampleDataByTemplate = (templateName) => {
  switch (templateName) {
    case 'customer_data.csv':
      return generateCustomerDataCSV();
    case 'loan_data.csv':
      return generateLoanDataCSV();
    case 'transaction_data.csv':
      return generateTransactionDataCSV();
    case 'credit_score.csv':
      return generateCreditScoreCSV();
    case 'compliance_report.csv':
      return generateComplianceReportCSV();
    default:
      return '';
  }
};
